export interface OrdinalStreamUpdate {
    ordinalId: string
    upvalueId?: string | number
}

type OrdinalStreamUpdateListener = (update: OrdinalStreamUpdate) => void

// A completed ordinal upvalue changes one or more ordinal rankings, but the
// visible wall must remain stable until the viewer explicitly refreshes it.
// UserChannel forwards the signal here; mounted ordinal panels turn it into
// the shared top update pill without touching React Query data.
const listeners = new Set<OrdinalStreamUpdateListener>()
const recentUpvalueIds = new Set<string>()
const recentUpvalueIdOrder: string[] = []
const MAX_RECENT_UPVALUE_IDS = 200

export function dispatchOrdinalStreamUpdate(update: OrdinalStreamUpdate) {
    if (update.upvalueId != null) {
        const upvalueId = String(update.upvalueId)
        if (recentUpvalueIds.has(upvalueId)) return
        recentUpvalueIds.add(upvalueId)
        recentUpvalueIdOrder.push(upvalueId)
        if (recentUpvalueIdOrder.length > MAX_RECENT_UPVALUE_IDS) {
            const expiredId = recentUpvalueIdOrder.shift()
            if (expiredId) recentUpvalueIds.delete(expiredId)
        }
    }

    listeners.forEach(listener => {
        try {
            listener(update)
        } catch (error) {
            console.error('>>> ordinal stream update listener error', error)
        }
    })
}

export function subscribeOrdinalStreamUpdates(listener: OrdinalStreamUpdateListener): () => void {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
